// src/pages/Hacienda/DteTestsProgressPage.tsx
import React, { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';
import ProgressCard from '../../components/Progress/ProgressCard';
import useTestProgress from '../../hooks/dte/useTestProgress';
import CertificateDownloadCard from '../../components/Progress/CertificateDownloadCard';

// src/pages/Hacienda/DteTestsProgressPage.tsx
const DteTestsProgressPage: React.FC = () => {
  const { progress, loading, fetchProgress } = useTestProgress();

  useEffect(() => {
    fetchProgress();
  }, []);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <div className="space-y-10 p-6">
          {/* LOADING */}
          {loading && (
            <p className="text-gray-600 dark:text-gray-400 text-center">
              Cargando progreso de pruebas...
            </p>
          )}

          {/* CUANDO YA TENEMOS DATOS */}
          {progress && (
            <>
              {/* ================== EMISIÓN ================== */}
              <div>
                <h3 className="mb-4 text-lg font-semibold text-black dark:text-white">
                  Emisión de Documentos
                </h3>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                  {progress.emission.map((item) => (
                    <ProgressCard
                      key={item.requirementId}
                      title={item.documentName}
                      code={item.documentCode}
                      completedCount={item.completedCount}
                      requiredCount={item.requiredCount}
                      completed={item.completed}
                    />
                  ))}
                </div>
              </div>

              {/* ================== ANULACIÓN / CONTINGENCIA ================== */}
              <div>
                <h3 className="mb-4 text-lg font-semibold text-black dark:text-white">
                  Eventos Especiales
                </h3>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                  <ProgressCard
                    title="Anulación"
                    completedCount={progress.annulation.completedCount}
                    requiredCount={progress.annulation.requiredCount}
                    completed={progress.annulation.completed}
                  />

                  <ProgressCard
                    title="Contingencia"
                    completedCount={progress.contingency.completedCount}
                    requiredCount={progress.contingency.requiredCount}
                    completed={progress.contingency.completed}
                  />
                </div>
              </div>
            </>
          )}

          {/* ================== CERTIFICADO ================== */}
          <div>
            <h3 className="mb-4 text-lg font-semibold text-black dark:text-white">
              Certificado de Culminación
            </h3>

            <CertificateDownloadCard />
          </div>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default DteTestsProgressPage;
